let config = window.webformOrangeConf;

export default {
  config: config,
  mode: {
    orange: 'orange',
    heyfix: 'heyfix'
  },
  dateFormat: "YYYY-MM-DD HH:mm:ss",
  routes: {
    home: {
      url: "/",
      title: "Home",
    },
    reset: {
      url: "/reset",
      title: "Reset",
    },
    reset_cgn: {
      url: "/reset/cgn",
      title: "Reset",
    },
    appointments: {
      url: "/appointments",
      title: "Interventions",
    },
    cgn_login: {
      url: "/cgn/login",
      title: "CGN - Login",
    },
    cgn: {
      url: "/cgn",
      title: "CGN",
    },
    activations: {
      url: "/activations",
      title: "Activations",
    },
    notfound: {
      url: "*",
      title: "Erreur 404",
    },
  },
};



// WEBPACK FOOTER //
// ./src/consts/consts.js